import { makeStyles } from '@material-ui/core/styles';

export const createReportStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(4)
  },
  container: {
    width: 900,
    margin: theme.spacing(2),
    padding: theme.spacing(2)
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  createUsersHeading: {
    fontSize: '1.2rem',
    fontWeight: 600,
    marginTop: theme.spacing(2)
  },
  currentUsersContainer: {
    maxHeight: 360,
    overflowY: 'scroll'
  },
  userRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  }
  // errorText: {
  //   color: '#f44336',
  //   textAlign: 'center',
  //   display: 'block',
  //   margin: theme.spacing(3)
  // }
}));
